/*
  Loox group rating reader (Haptic). Loox's rating widget shows the review group's figures ("4.9 · 450 reviews"),
  while the product metafields (loox.avg_rating / loox.num_reviews) hold only this product's (109). Sections that
  show a count read it here, so every count on the page matches the widget.

  - Sources: elements marked [data-loox-group-source] that contain a Loox rating widget, kept visually hidden
    (the Cash Wrap buy box's app block slot; the Curated reviews section's own hidden widget, priority 2, used
    only on pages without the buy box).
  - Watches each source until Loox has rendered a rating and a count, takes the largest count, then caches the
    result on window.hapticLooxGroup = { rating, count } and fires "haptic:loox-group" on document
    (event.detail is the same object). Read the cache first, then listen for the event, so load order doesn't
    matter.
  - Gives up 10 seconds after the page has loaded (Loox blocked or slow): no event, sections keep their fallbacks
    (or, if only the lower-priority fallback widget rendered, its figures are used then).
*/
(function () {
  if (window.HapticLooxGroup) return;

  var observers = [];
  var watched = [];
  var resolved = [];
  var held = null; // best result so far, waiting on a higher-priority source: { priority, result }
  var done = false;

  // Sources carry a priority (data-loox-group-source="2"; empty = 1). A result from a lower-priority source (the
  // Curated reviews fallback widget) is held while a higher-priority one (the buy box's Loox block) is still
  // loading, so the buy box's figures win when both are on the page. Held results are used when the reader gives up.
  function priority(el) {
    return Number(el.getAttribute('data-loox-group-source')) || 1;
  }

  function parse(source) {
    var widget = source.querySelector('.loox-rating') || source.querySelector('[class*="loox"]');
    if (!widget) return null;
    var text = (widget.textContent || '') + ' ' + (widget.getAttribute('aria-label') || '');
    var nums = (text.match(/\d[\d,.]*/g) || []).map(function (n) {
      return n.replace(/,/g, '').replace(/\.$/, '');
    });
    // Counts: whole numbers above 5 (star icons and the rating are 5 or less). The group total is the largest.
    var counts = nums.filter(function (n) { return /^\d+$/.test(n) && Number(n) > 5; }).map(Number);
    var rating = nums.filter(function (n) { return /^\d\.\d+$/.test(n) && Number(n) <= 5; })[0]
      || widget.getAttribute('data-rating');
    if (!counts.length || !rating || isNaN(Number(rating))) return null;
    return { rating: Number(Number(rating).toFixed(1)), count: Math.max.apply(null, counts) };
  }

  function stop() {
    observers.forEach(function (o) { o.disconnect(); });
    observers = [];
  }

  function found(result) {
    if (done) return;
    done = true;
    stop();
    window.hapticLooxGroup = result;
    document.dispatchEvent(new CustomEvent('haptic:loox-group', { detail: result }));
  }

  function consider(source, result) {
    if (done || resolved.indexOf(source) !== -1) return;
    resolved.push(source);
    var p = priority(source);
    if (!held || p < held.priority) held = { priority: p, result: result };
    var waiting = watched.some(function (s) { return priority(s) < held.priority && resolved.indexOf(s) === -1; });
    if (!waiting) found(held.result);
  }

  function watch(source) {
    if (done) return;
    var result = parse(source);
    if (result) return consider(source, result);
    if (!('MutationObserver' in window)) return;
    var observer = new MutationObserver(function () {
      var r = parse(source);
      if (r) {
        observer.disconnect();
        consider(source, r);
      }
    });
    observer.observe(source, { childList: true, subtree: true, characterData: true, attributes: true });
    observers.push(observer);
  }

  function scan() {
    var sources = Array.prototype.slice.call(document.querySelectorAll('[data-loox-group-source]'));
    var fresh = sources.filter(function (el) { return watched.indexOf(el) === -1; });
    // Register them all before reading any, so a fallback that has already rendered waits for the others
    fresh.forEach(function (el) { watched.push(el); });
    fresh.forEach(watch);
  }

  window.HapticLooxGroup = { scan: scan, parse: parse };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  // Sections re-rendered in the theme editor
  document.addEventListener('shopify:section:load', scan);

  var giveUp = function () {
    setTimeout(function () {
      if (done) return;
      if (held) found(held.result);
      else stop();
    }, 10000);
  };
  if (document.readyState === 'complete') giveUp();
  else window.addEventListener('load', giveUp, { once: true });
})();
